import { render, staticRenderFns } from "./ClerkOrdersOverviewComponent.vue?vue&type=template&id=c78b74ba"
import script from "./ClerkOrdersOverviewComponent.vue?vue&type=script&lang=js"
export * from "./ClerkOrdersOverviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports